/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useRef } from 'react';
import { useI18n } from '@whizz/react-i18n';
import { SaveButton } from '../../../../../global';
import { getIconComponent } from '../../../../../util/reactFunc';
import { Button } from '../../../../../components';
import { Formik } from 'formik';
import { useMutation } from 'react-query';
import { repository } from '@whizz/api-client';
import { useCleverIntegration } from '../../../../../hooks/useCleverIntegration';

interface FileUploadForm {
  onSuccess: () => void;
  onError: () => void;
}

const FileUploadForm = ({ onSuccess, onError }: FileUploadForm): JSX.Element => {
  const { translate } = useI18n();
  const [ isClever ] = useCleverIntegration();

  const inputFileRef = useRef<HTMLInputElement>(null);

  const mutation = useMutation(
    ({ files }: { files: FileList }) => repository.UploadRepository.addFiles(files),
  );

  return (
    <Formik<{ files: FileList | null }>
      onSubmit={(values, { resetForm }) => {
        mutation.mutate(
          { files: values.files! },
          {
            onSuccess: () => {
              onSuccess();
              resetForm();
            },
            onError: () => {
              onError();
            },
          },
        );
      }}
      initialValues={{ files: null }}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className={'flex items-center space-x-2'}>
            {(null != values.files && 0 < values.files.length) && (
              <div className={'flex items-center'}>
                {getIconComponent('Attachment')}<span className={'ml-2'}>{values.files[0].name}</span>
              </div>
            )}
            <SaveButton
              onClick={() => inputFileRef?.current?.click()}
              disabled={isClever}
            >
              {translate('pages.ROSTER_MANAGEMENT.UPLOAD.BUTTONS.SELECT')}
            </SaveButton>
            <input
              ref={inputFileRef}
              type="file"
              className={'hidden'}
              onChange={(event) => setFieldValue('files', event.target.files)}
            />
            <Button
              type={'submit'}
              icon={'Publish'}
              color={'positive'}
              isOutline
              disabled={null == values.files || 0 === values.files.length || mutation.isLoading}
            >
              {translate(`pages.ROSTER_MANAGEMENT.UPLOAD.BUTTONS.${mutation.isLoading ? 'SENDING' : 'SEND'}`)}
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default FileUploadForm;
